module.exports = {};



//////////////////
// WEBPACK FOOTER
// /home/runner/work/slipresistant/slipresistant/client/~/core-js/internals/iterators.js
// module id = BDpI
// module chunks = 0 3